import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/uk'

export const formatDate = (timestamp: number | null): string => {
  if (!timestamp) {
    return '';
  }

  // convert seconds to milliseconds
  const date = new Date(timestamp * 1000);

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};

export function getTimeAgoString(pastDate: Date | string, locale: string) {
  // TODO: remove Z after backend fix
  dayjs.locale(locale);

  const date = dayjs(`${pastDate}Z`);

  return `${locale === 'de' ? 'Bearbeitet' : locale === 'uk' ? 'Відредаговано' : 'Edited'} ${date.fromNow()}`;
}

export const addZToDate = (date: string) => `${date}Z`;

export const getDayJsDate = (date?: string | dayjs.Dayjs) => {
  if (date === '' || date === undefined) {
    return;
  }
  if (date instanceof dayjs) {
    return date as dayjs.Dayjs;
  }

  return dayjs(date);
};
